/* kwadwo.7 homepage theme: header, menus, colour scheme and the combined feed */
(function () {
  'use strict';

  /* Header: scrolled state */
  var header = document.querySelector('[data-kw-header]');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.pageYOffset > 50);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Desktop dropdowns */
  var toggles = document.querySelectorAll('[data-kw-submenu-toggle]');
  function closeAll(except) {
    toggles.forEach(function (t) {
      var li = t.parentElement;
      if (li !== except) { li.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); }
    });
  }
  toggles.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.stopPropagation();
      var li = t.parentElement;
      var open = !li.classList.contains('is-open');
      closeAll(li);
      li.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('.kw-nav__item')) closeAll(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(null); setMenu(false); } });

  /* Mobile menu */
  var burger = document.querySelector('[data-kw-burger]');
  var menu = document.querySelector('[data-kw-mobile-menu]');
  function setMenu(open) {
    if (!burger || !menu) return;
    menu.hidden = !open;
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('kw-menu-open', open);
  }
  if (burger) burger.addEventListener('click', function () { setMenu(menu.hidden); });
  if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });

  /* Colour scheme toggle: system -> opposite of system -> system */
  function systemDark() { return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches; }
  document.querySelectorAll('[data-kw-scheme-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var root = document.documentElement;
      var cur = root.getAttribute('data-color-scheme') || 'system';
      var effective = cur === 'system' ? (systemDark() ? 'dark' : 'light') : cur;
      var next = effective === 'dark' ? 'light' : 'dark';
      if ((next === 'dark') === systemDark()) next = 'system';
      root.setAttribute('data-color-scheme', next);
      try { localStorage.setItem('kw-color-scheme', next); } catch (e) {}
    });
  });

  /* CTA links to the hero form: focus the email field */
  document.querySelectorAll('a[href="/#colour-combo"], a[href="#colour-combo"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var hero = document.getElementById('colour-combo');
      if (!hero) return;
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      var input = hero.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
    });
  });

  /* Feed: journal rows (server-rendered) + latest YouTube uploads */
  var feed = document.querySelector('[data-kw-feed]');
  if (!feed) return;

  var list = feed.querySelector('[data-kw-feed-list]');
  var loading = feed.querySelector('[data-kw-feed-loading]');
  var empty = feed.querySelector('[data-kw-feed-empty]');
  var pager = feed.querySelector('[data-kw-pager]');
  var prevBtn = feed.querySelector('[data-kw-prev]');
  var nextBtn = feed.querySelector('[data-kw-next]');
  var pageLabel = feed.querySelector('[data-kw-page-label]');
  var avatarTpl = feed.querySelector('[data-kw-avatar-tpl]');
  var perPage = parseInt(feed.dataset.perPage, 10) || 12;
  var maxVideos = parseInt(feed.dataset.maxVideos, 10) || 30;
  var channelId = feed.dataset.channelId;
  var uploadsId = feed.dataset.uploadsId;
  var apiKey = feed.dataset.apiKey;
  var filter = 'all';
  var page = 1;
  var CACHE_KEY = 'kw-yt-' + channelId;
  var CACHE_MS = 30 * 60 * 1000;

  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmt(d) { return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear(); }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function decode(s) { var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }

  function buildVideoRow(v) {
    var art = document.createElement('article');
    art.className = 'kw-row';
    art.setAttribute('data-kw-item', '');
    art.dataset.type = 'video';
    art.dataset.tags = '';
    art.dataset.date = v.date.toISOString();
    var a = document.createElement('a');
    a.className = 'kw-row__link';
    a.href = v.url;
    a.target = '_blank';
    a.rel = 'noopener';
    var h = document.createElement('h3');
    h.className = 'kw-row__title';
    h.textContent = v.title;
    var type = document.createElement('span');
    type.className = 'kw-row__type';
    type.innerHTML = '<span class="kw-badge kw-badge--video">Video</span>';
    var time = document.createElement('time');
    time.className = 'kw-row__date';
    time.setAttribute('datetime', iso(v.date));
    time.textContent = fmt(v.date);
    var author = document.createElement('span');
    author.className = 'kw-row__author';
    if (avatarTpl) author.appendChild(avatarTpl.content.cloneNode(true));
    a.appendChild(h); a.appendChild(type); a.appendChild(time); a.appendChild(author);
    art.appendChild(a);
    return art;
  }

  function readCache() {
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < CACHE_MS) return c.v;
    } catch (e) {}
    return null;
  }
  function writeCache(v) { try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {} }

  function fromApi() {
    var url = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet,contentDetails&maxResults=' +
      Math.min(maxVideos, 50) + '&playlistId=' + encodeURIComponent(uploadsId) + '&key=' + encodeURIComponent(apiKey);
    return fetch(url).then(function (r) { if (!r.ok) throw new Error('api'); return r.json(); }).then(function (j) {
      return (j.items || []).filter(function (it) {
        return it.snippet && it.snippet.title !== 'Private video' && it.snippet.title !== 'Deleted video';
      }).map(function (it) {
        var id = it.contentDetails.videoId;
        return { title: it.snippet.title, url: 'https://www.youtube.com/watch?v=' + id, date: it.contentDetails.videoPublishedAt || it.snippet.publishedAt };
      });
    });
  }
  function fromRss() {
    var rss = 'https://www.youtube.com/feeds/videos.xml?channel_id=' + channelId;
    var url = 'https://api.rss2json.com/v1/api.json?rss_url=' + encodeURIComponent(rss);
    return fetch(url).then(function (r) { if (!r.ok) throw new Error('rss'); return r.json(); }).then(function (j) {
      if (j.status !== 'ok') throw new Error('rss');
      return (j.items || []).map(function (it) {
        return { title: decode(it.title), url: it.link, date: it.pubDate.replace(' ', 'T') + 'Z' };
      });
    });
  }

  function loadVideos() {
    if (!channelId) return Promise.resolve([]);
    var cached = readCache();
    if (cached) return Promise.resolve(cached);
    var p = apiKey ? fromApi().catch(fromRss) : fromRss();
    return p.then(function (v) { v = v.slice(0, maxVideos); writeCache(v); return v; }).catch(function () { return []; });
  }

  function items() { return Array.prototype.slice.call(list.querySelectorAll('[data-kw-item]')); }
  function matches(el) {
    if (filter === 'all') return true;
    if (filter === 'video' || filter === 'journal') return el.dataset.type === filter;
    return (' ' + el.dataset.tags + ' ').indexOf(' ' + filter + ' ') > -1;
  }

  function render() {
    var all = items();
    var visible = all.filter(matches);
    var pages = Math.max(1, Math.ceil(visible.length / perPage));
    if (page > pages) page = pages;
    var start = (page - 1) * perPage;
    all.forEach(function (el) { el.hidden = true; });
    visible.slice(start, start + perPage).forEach(function (el) { el.hidden = false; });
    empty.hidden = visible.length > 0;
    pager.hidden = pages <= 1;
    pageLabel.textContent = 'Page ' + page + ' of ' + pages;
    prevBtn.disabled = page <= 1;
    nextBtn.disabled = page >= pages;
  }

  function sortRows() {
    var all = items();
    all.sort(function (a, b) { return new Date(b.dataset.date) - new Date(a.dataset.date); });
    all.forEach(function (el) { list.insertBefore(el, loading); });
  }

  prevBtn.addEventListener('click', function () { if (page > 1) { page--; render(); feed.scrollIntoView({ behavior: 'smooth' }); } });
  nextBtn.addEventListener('click', function () { page++; render(); feed.scrollIntoView({ behavior: 'smooth' }); });

  var tabs = feed.querySelectorAll('[data-kw-filter]');
  function setFilter(f) {
    filter = f; page = 1;
    tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.kwFilter === f); });
    render();
  }
  tabs.forEach(function (t) { t.addEventListener('click', function () { setFilter(t.dataset.kwFilter); }); });
  document.querySelectorAll('[data-kw-footer-filter]').forEach(function (a) {
    a.addEventListener('click', function () { setFilter(a.dataset.kwFooterFilter); });
  });

  render();
  loadVideos().then(function (videos) {
    videos.forEach(function (v) {
      var d = new Date(v.date);
      if (isNaN(d)) return;
      list.insertBefore(buildVideoRow({ title: v.title, url: v.url, date: d }), loading);
    });
    sortRows();
    loading.remove();
    render();
  });
})();
